<template>
  <v-container fluid>
    <v-row align="end" class="white data-inline-content">
      <v-col :cols="is_mobile ? 12 : 6">
        <span class="data-inline-header-content-reference">
          {{ json.get_model_name('reference',lang) || 'reference'}}
        </span>
        <span class="pl-1 data-inline-header-content-title">
          {{ json.get_model_name('title',lang) || 'title'}}
        </span>
      </v-col>
      <v-spacer></v-spacer>
      <v-col class="end data-inline-header" :cols="is_mobile ? 12 : false">
        <v-btn 
          icon
          dense
          style="width: auto;"
        >
          <!-- TODO: Copy code to clipboard -->
          <div class="pa-1" style="white-text: nowrap">
            <small class="data-inline-header-copy" style="display: block">
              {{ $vuetify.lang.translator('inlineboxes.inlinebox_data.copy_email') }}
            </small>
          </div>
          <v-icon right large class="data-inline-header-copy-icon">
            mdi-clipboard-text-multiple
          </v-icon>
        </v-btn>
      </v-col>
      <v-col class="data-inline-header" :cols="is_mobile ? 12 : 2">
        <span class="label data-inline-header-label"> {{ $vuetify.lang.translator('inlineboxes.inlinebox_data.responsible') }} </span>
        <span class="data-inline-header-title">
          current_workflow_responsible
        </span>
      </v-col>
      <v-col class="data-inline-header" md="auto" :cols="is_mobile ? 12 : false">
        <span class="label data-inline-header-label">{{ $vuetify.lang.translator('limit') }}</span>
        <span>
          current_workflow_limit
        </span>
      </v-col>
      <v-col class="data-inline-header-checkbox" v-if="!is_mobile">
        <v-icon
          v-if="check_value"
          @click="toogle(!check_value)" 
          class="mr-3"
        >
            mdi-checkbox-marked
        </v-icon>
        <v-icon 
          v-else 
          @click="toogle(!check_value)"
          class="mr-3"
        >
          mdi-checkbox-blank-outline
        </v-icon>
      </v-col>
    </v-row>
    <v-row :class="is_mobile ? 'data-inline-mobile' : ''">
      <v-expansion-panels multiple v-model="extended">
        <v-expansion-panel
          v-for="(group,group_index) in parsed_fields.layout"
          :key="group.id"
        >
          <!-- GROUP -->
          <v-expansion-panel-header class="data-inline-expand-header">
            <span class="data-inline-expand-title" @click.stop="modify_group(group,group_index)">{{ group.title[lang] }}</span>
            <template v-slot:actions>
              <DeleteButton
                v-if="!readonly"
                title="Delete Group"
                :text="group.title[lang]"
                custom_icon="mdi-trash-can-outline"
                @submit="remove_group(group_index)"
              >
                <template v-slot:content="">
                  <v-expansion-panel-header class="data-inline-expand-header pa-2 no_click">
                    <span class="data-inline-expand-title">{{ group.title[lang] }}</span>
                    <template v-slot:actions>
                      <v-icon
                        class="data-inline-expand-icon"
                      >
                        mdi-chevron-down
                      </v-icon>
                    </template>
                  </v-expansion-panel-header>
                </template>
              </DeleteButton>
              <v-icon 
                class="data-inline-expand-icon"
              >
                mdi-chevron-down
              </v-icon>
            </template>
          </v-expansion-panel-header>
          <!-- GROUP CONTENT LAYOUT -->
          <v-expansion-panel-content>
            <v-row v-for="(row, row_index) in group.rows" :key="row_index">
              <v-col
                v-for="(col, col_index) in row"
                :key="col_index"
                :cols="is_mobile ? 12 : col.props.cols"
                v-if="!is_mobile || (col.props.label || col.props.value)"
              >
                <div :class="[is_mobile ? 'qmkey-flex-box' : '',!readonly ? 'somith qmkey-custom-input' : '']">
                  <span class="data-inline-data-title">
                    {{ col.props.label }}
                  </span>
                  <span v-if="is_mobile && col.props.label" class="qmkey-inline-content-mobile">
                    :
                  </span>
                  <div
                    class="qmkey-inline-content-value "
                    :class="
                      col.props.class
                        ? col.props.class
                        : ['data-inline-data', 'text-justify']
                    "
                  >
                    <div style="position: relative;">
                      <Field
                        class="no_click"
                        :field="col"
                      />
                    </div>
                    <div
                      v-if="!readonly"
                      class="qmkey-form-input-actions"
                    >
                      <div style="width: 75%; height: 100%;" class="qmkey-form-input-button">
                        <v-icon
                        small
                          @click="modify_field(group_index,row_index,col_index)"> mdi-pencil </v-icon>
                      </div>
                      <div style="width: 25%; height: 100%;" class="qmkey-form-input-button">
                        <DeleteButton
                          v-if="!readonly"
                          title="Delete Field"
                          :text="col.props.label"
                          custom_icon="mdi-trash-can-outline"
                          @submit="delete_item(group_index,row_index,col_index)"
                        >
                          <template v-slot:content="">
                            <span class="data-inline-data-title">
                              {{ col.props.label }}
                            </span>
                          </template>
                          
                        </DeleteButton>
                      </div>
                    </div>
                  </div>
                </div>
              </v-col>
              <!-- Row is parsed, need raw or the 'props' property of the parsed row in order to get the 'cols' property -->
              <v-col v-if="!readonly && row.length && max_row_space(row.map(it => (it.props || {}))) > 0">

                <v-btn
                  icon
                  @click="new_field(group_index,row_index)"
                  fab
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row v-if="!readonly">
                <v-btn
                  icon
                  @click="new_field(group_index,group.rows.length)"
                  fab
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-btn
        v-if="!readonly"
        icon
        @click="new_group"
        fab
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
      <AddFormItem
        v-if="!readonly"
        hide_button
        :open="open"
        :fields="(field_to_modify || {}).data"
        @close="close_modal"
        @submit="(values) => {field_to_modify.submit(values)}"
      />
    </v-row>
  </v-container>
</template>

<style lang="scss">
@import '@/sass/explorer.scss';
.data-inline-mobile {
  font-size: small !important;
}
.qmkey-inline-content-mobile {
  margin-right: 1em;
}
.qmkey-inline-content-value {
  overflow: auto;
}
.qmkey-flex-box {
  display: flex;
}
.somith {
  background-color: lightgray;
}
</style>
<script>
import Field from '@/components/qfields/Field'
import AddFormItem from '@/components/bpcreator/model/AddFormItem';
  import DeleteButton from '@/components/DeleteButton';

export default {
  name: 'DataInline',

  props: {
    json: {default: () => ({})},
    raw_fields: {default: () => ({})},
    parsed_fields: {default: () => ({})},
    is_mobile: {type: Boolean, default: false},
    readonly: Boolean,
    lang: String,
    roles: {default: ()=>({})},
  },

  components: {
    Field,
    AddFormItem,
    DeleteButton,
  },

  data() {
    return {
      extended: [],
      value: true,
      field_to_modify: {},
      open: false,
    }
  },
  mounted: function() {
    this.all();
  },
  computed: {
    check_value() {
      return this.extended.length == (this.raw_fields.content || []).length
    },
  },
  methods: {
    // Create an array the length of our items
    // with all values as true
    all() {
      let extend = [];
      for (var i = 0; i < (this.parsed_fields.layout || []).length; i++) {
        extend.push(i);
      }
      this.extended = extend;
    },
    // Reset the panel
    none() {
      this.extended = [];
    },
    toogle(value) {
      if (value) {
        this.all();
      } else {
        this.none();
      }
    },
    
    update(values) {
      this.$emit('update',values)
    },

    update_layout(value) {
      const parsed_value = {...value};
      let new_inline = {...this.raw_fields};

      if (this.field_to_modify.row < new_inline.content[this.field_to_modify.group].rows.length) {
        //Update group layout
        new_inline.content[this.field_to_modify.group].rows[this.field_to_modify.row][this.field_to_modify.col] = parsed_value;
      } else {
        //Add group layout
        new_inline.content[this.field_to_modify.group].rows.push([parsed_value])
      }
      
      this.update(new_inline)
    },

    update_group(value) {
      let new_inline = {...this.raw_fields};
      if(this.field_to_modify.group >= this.raw_fields.content.length) {
        //New group
        new_inline.content.push(value);
      } else {
        new_inline.content[this.field_to_modify.group] = value;
      }
      this.update(new_inline)
    },

    open_modal() {
      if (!this.readonly) {
        this.open = true;
      }
    },

    close_modal() {
      this.open = false;
      this.field_to_modify = {};
    },

    modify_field(group,row,col) {
      const row_unused_cols = this.max_row_space(this.raw_fields.content[group].rows[row]);
      const current_field = {...this.raw_fields.content[group].rows[row][col]}
      this.field_to_modify.group = group;
      this.field_to_modify.row = row;
      this.field_to_modify.col = col;
      this.field_to_modify.data = this.fields_to_colect(current_field.cols+row_unused_cols,current_field);
      this.field_to_modify.submit = this.update_layout;
      this.open_modal();
    },

    new_field(group,row) {
      this.field_to_modify.row = row || 0;
      this.field_to_modify.col = (this.raw_fields.content[group].rows[row] || []).length || 0;
      this.field_to_modify.group = group;
      this.field_to_modify.data = this.fields_to_colect(this.max_row_space(this.raw_fields.content[group].rows[row] || []));
      this.field_to_modify.submit = this.update_layout;
      this.open_modal();
    },

    delete_item(group,row,col) {
      let new_fields = {...this.raw_fields};
      let new_group = new_fields.content[group];
      let new_row = new_group.rows[row];
      //Just remove 1 item
      new_row.splice(col,1);
      new_group.rows[row] = new_row;
      if (new_group.rows[row].length <= 0) {
        new_group.rows.splice(row, 1);
      }
      new_fields.content[group] = new_group;
      this.$emit('update',new_fields);
    },

    fields_to_colect(max_cols,field) {
      return [
          [
            {
              id:	"id",
              label: "Id",
              required: false,
              value: (field || {}).id,
              items: Object.keys((this.json.raw || {}).model || {}) || [],
              cols:	3,
              class: null,
              component: "Select",
              placeholder: "Id",
            },  
            {
              id:	"cols",
              label: "Cols",
              required: true,
              value: (field || {}).cols || 1,
              cols:	3,
              class: null,
              component: "NumericInput",
              placeholder: "Cols",
              min: 1,
              max: max_cols || 0,
            },
          ],
          [
            {
              id:	"value",
              label: "Value",
              required: false,
              value: (field || {}).value || "",
              cols:	3,
              class: null,
              component: "TextInput",
              placeholder: "Value",
            },
            {
              id:	"class",
              label: "Class",
              required: false,
              value: (field || {}).class || "",
              cols:	3,
              class: null,
              component: "TextInput",
              placeholder: "Class",
            }
          ]
        ]
    },

    group_field(group) {
      return [[
        {
          id:	"id",
          label: "Id",
          required: true,
          value: (group || {}).id,
          cols:	4,
          class: null,
          component: "TextInput",
        },
        {
          id:	"title",
          label: "Title",
          required: true,
          value: (group || {}).title,
          cols:	4,
          class: null,
          component: "DictInput",
        },
        {
          id:	"rows",
          label: "Rows",
          required: true,
          value: (group || {}).rows || [],
          cols:	4,
          class: null,
          component: "Select",
          hidden: true,
        },
      ]];
    },

    new_group() {
      this.field_to_modify.group = this.raw_fields.content.length;
      this.field_to_modify.row = 0;
      this.field_to_modify.col = 0;
      this.field_to_modify.data = this.group_field();
      this.field_to_modify.submit = this.update_group;
      this.open_modal();
    },

    modify_group(group,group_index) {
      this.field_to_modify.group = group_index;
      this.field_to_modify.data = this.group_field(group);
      this.field_to_modify.submit = this.update_group;
      this.open_modal();
    },

    remove_group(group_index) {
      let new_fields = {...this.raw_fields};
      //Remove group
      new_fields.content.splice(group_index,1);
      this.$emit('update',new_fields);
    },

    max_row_space(row) {
      // Using raw rows (parsed rows would have 'cols' property inside 'props' property)
      return 12-(row.reduce((accumulator, currentValue) => accumulator + ((currentValue || {}).cols || 0), 0))
    },
  },
}
</script>
